import colors from './style/js-colors';
import CustomEvent from 'custom-event';

const VSTUI = { colors };
VSTUI.theme = {
  primary: VSTUI.colors.OCEAN,
  accent: VSTUI.colors.CHEDDAR,
  primaryKey: 'OCEAN',
  accentKey: 'CHEDDAR',
  get: (index) => ({
    primary: VSTUI.theme.getPrimary(index),
    accent: VSTUI.theme.getAccent(index)
  }),
  getPrimary: (index) => VSTUI.theme.primary[index],
  getAccent: (index) => VSTUI.theme.accent[index]
};

VSTUI.changeTheme = (primary = 'OCEAN', accent = 'CHEDDAR', customKey = false) => {
  if (typeof primary === 'object' && customKey) {
    // this is a custom theme
    if (primary.length === 11) {
      VSTUI.theme.primary = primary;
      VSTUI.theme.accent = accent && accent.length === 11 ? accent : primary;
      VSTUI.theme.primaryKey = `${customKey}_primary`;
      VSTUI.theme.accentKey = `${customKey}_accent`;
    } else {
      console.error('Invalid custom theme! Must be 11 elements in length.');
    }
  } else {
    VSTUI.theme.primary = VSTUI.colors[primary];
    VSTUI.theme.accent = VSTUI.colors[accent];
    VSTUI.theme.primaryKey = primary;
    VSTUI.theme.accentKey = accent;
  }
  const event = new CustomEvent('_vstui_change_theme', {});
  document.dispatchEvent(event);
};

VSTUI.VSTUI = VSTUI;

export default VSTUI;
